module.exports = __webpack_public_path__ + "static/media/comments-alt-dollar.de21da07.svg";